import React from 'react';

const idIDN: React.FC = () => (
  <svg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M0 0H16V6H0V0Z' fill='#F71408' />
    <path d='M0 6H16V12H0V6Z' fill='white' />
  </svg>
);

export default idIDN;

